import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

import { Icon } from '..';

const Select = (props) => {
  const [listVisible, setListVisible] = useState(false);

  const handleOutside = () => {
    setListVisible(false);
    document.removeEventListener('click', handleOutside);
  };

  useEffect(() => {
    if (listVisible) {
      document.addEventListener('click', handleOutside);
    }
  }, [listVisible]);

  return (
    <div className={`select__container${props.className ? ` ${props.className}` : ''}`}>
      <button 
        className={`select__container_selector ${listVisible && 'opened'}`} 
        type="button" 
        onClick={() => setListVisible(!listVisible)} 
        disabled={props.disabled}>
        {props.options.find((el) => el.value === props.value)?.label}
        <Icon name="arrow-down" />
      </button>
      {listVisible && (
        <div className="options">
          {props.options.map((el) => (
            <div className="option" onClick={() => {props.setValue(el.value); props.onChange(el.value)}}>
              <input id={el.key} type="radio" value={el.value === props.value} />
              <label for={el.key}>{el.label}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
Select.defaultProps = {
  options: [],
  value: '',
  setValue: () => {},
  disabled: false,
  className: '',
};

export default Select;
